import angular from 'angular';
import { errorScreenDecorator } from './decorator/errorScreenDecorator';
import { errorScreenComponent } from './component/errorScreenComponent';
import { ErrorScreenService } from './service/ErrorScreenService';
import 'components/sharpr/zIndex/top/zIndexTopModule';

angular
	.module('sh.errorScreen', ['sh.zIndexTop'])
	.config(errorScreenDecorator)
	.component('shErrorScreen', errorScreenComponent())
	.service('ErrorScreen', ErrorScreenService);
